import { useState, useEffect } from 'react';

export const useLatestTermCode = () => {
  const [termCode, setTermCode] = useState(null);
  const [termLabel, setTermLabel] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getTermData = async () => {
      setIsLoading(true);
      try {
        // Reorder proxies to try the working one first
        const proxyUrls = [
          'https://api.allorigins.win/raw?url=',
          'https://api.codetabs.com/v1/proxy?quest=',
          'https://corsproxy.io/?'
        ];
        
        // Set a reasonable timeout
        const timeoutDuration = 8000; // 8 seconds
        
        let succeeded = false;
        let lastError = null;
        
        for (const proxyUrl of proxyUrls) {
          if (succeeded) break;
          
          try {
            const targetUrl = 'https://registrar.kfupm.edu.sa/exams-grades/final-exam-schedule/';
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), timeoutDuration);
            
            const response = await fetch(proxyUrl + encodeURIComponent(targetUrl), {
              method: 'GET',
              headers: { 'Accept': 'text/html' },
              signal: controller.signal
            });
            
            clearTimeout(timeoutId);
            
            if (response.ok) {
              const html = await response.text();
              
              // Extract both the value and text from option elements
              const optionRegex = /<option.*?value="(\d+)">Term (\d+)<\/option>/g;
              const matches = [...html.matchAll(optionRegex)];
              
              if (matches.length > 0) {
                // Sort by value to get the most recent term
                const sortedMatches = matches.sort((a, b) => 
                  parseInt(b[1]) - parseInt(a[1])
                );
                
                // Get the value for API calls (e.g., "202420")
                setTermCode(sortedMatches[0][1]);
                
                // Get the text for display (e.g., "Term 242")
                setTermLabel(`Term ${sortedMatches[0][2]}`);
                
                succeeded = true;
                setIsLoading(false);
                return;
              } else {
                throw new Error("Could not find term data in the response");
              }
            } else {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
          } catch (proxyError) {
            lastError = proxyError;
          }
        }
        
        // If all proxies failed, throw the last error
        if (!succeeded) {
          throw lastError || new Error("All proxies failed");
        }
        
      } catch (err) {
        setError(`Failed to retrieve term data: ${err.message}`);
        setIsLoading(false);
      }
    };
    
    getTermData();
  }, []);

  return { termCode, termLabel, isLoading, error };
};